import { render, staticRenderFns } from "./AddressFilter.vue?vue&type=template&id=edb3aede"
import script from "./AddressFilter.vue?vue&type=script&lang=js"
export * from "./AddressFilter.vue?vue&type=script&lang=js"
import style0 from "./AddressFilter.vue?vue&type=style&index=0&id=edb3aede&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports